/**
 * Factory para realizar el bind del scope.
 * Es para crear por ej. scope.CAB y scope.LIN para que funcione las expressiones etc...
 *
 * @param {object} data - objeto encapsulando los datos, ej: "{CAB: {...}}"
 *
 * @return {function}
 */

import { bindDataFactory } from './bindDataFactory';
import { bindRegisterFactory } from './bindRegisterFactory';

export function bindFactory(data, ecFormBuilderController) {
  const bindData = bindDataFactory(data);
  const bindRegister = bindRegisterFactory(data);

  return function bind(scope, xPath, options) {
    scope.ecFormBuilderController = ecFormBuilderController;
    bindData(scope);
    bindRegister(scope, xPath, options);
  };
}
